import React, { useEffect } from "react";
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const PostLoginRedirect = () => {
  const navigate = useNavigate();
  const registerLoginUrl =
    "https://registerlogin-eosrmhmqna-uc.a.run.app";

  // Obtiene la IP pública del cliente usando el servicio ipify
  async function getPublicIp() {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    } catch (err) {
      console.error("No se pudo obtener la IP pública:", err);
      return null;
    }
  }

  useEffect(() => {
    async function checkUserHub() {
      const auth = getAuth();
      const user = auth.currentUser;

      // Si no hay usuario autenticado, redirigir a login
      if (!user) {
        navigate("/login");
        return;
      }

      // Obtener la IP pública antes de registrar el login
      const ipAddress = await getPublicIp();

      // Registrar login en el backend con email e IP
      const response = await fetch(registerLoginUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: user.email,
          ipAddress: ipAddress
        }),
      });

      console.log("Login registrado, respuesta del servidor:", response);

      if (!response.ok) {
        console.error("Error registrando login:", await response.text());
      }

      try {
        // Leer datos del usuario en Firestore
        const userDoc = await getDoc(doc(db, "usuarios", user.uid));
        if (!userDoc.exists()) {
          navigate("/login");
          return;
        }

        const userData = userDoc.data();
        const hubIds = userData.hubId; // array de hubs asignados al usuario

        // Si el usuario es superadmin puede elegir hub
        if (hubIds.includes("__superadmin__")) {
          navigate("/select-hub");
          return;
        }

        // Si el usuario tiene un solo hub, redirigir directamente
        if (hubIds.length === 1) {
          navigate(`/lobby/${hubIds[0]}`);
        } else if (hubIds.length > 1) {
          // Si tiene varios hubs, mostrar pantalla de selección
          navigate("/select-hub");
        } else {
          // Si no tiene hubs asignados, volver al login
          navigate("/login");
        }
      } catch (error) {
        console.error("Error leyendo usuario:", error);
        navigate("/login");
      }
    }

    checkUserHub();
  }, [navigate]);

  return <div>Cargando...</div>;
};

export default PostLoginRedirect;
